import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authSlice from "./reducers/authSlice";
import breadCrumbSlice from "./reducers/breadCrumbSlice";
import themeSlice from "./reducers/theme";
import questionsSlice from "./reducers/questions";
import questionnaireSlice from "./reducers/questionnaire";
import countSlice from "./reducers/count";

const rootReducer = combineReducers({
  auth: authSlice,
  breadcrumb: breadCrumbSlice,
  theme: themeSlice,
  questions: questionsSlice,
  questionnaire: questionnaireSlice,
  count: countSlice,
});
const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "auth",
    "breadcrumb",
    "theme",
    "questions",
    "questionnaire",
    "count",
  ],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: {
    root: persistedReducer,
  },
  middleware: (getDefaultMiddleware: any) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["register"],
        ignoredActionPaths: ["rehydrate", "register"],
        ignoredPaths: ["register"],
      },
    }),
});

const persistor = persistStore(store);
export { store, persistor };
